import React, { useEffect, useReducer } from 'react';
import { Dispatch } from 'redux';
import { connect } from 'dva';
import { Trans } from '@lingui/macro';
import { Button } from '@mos-cat/typography';
import { createStructuredSelector } from 'reselect';

import {
  isAddressCompleted,
  PersonModel,
  getDisableContinueButton,
  missingAddressInfo,
} from '../../../../selectors/addressUnmodeled';
import './styles.pcss';

interface Props {
  model: PersonModel;
  disabled: boolean;
  isAddressCompleted: boolean;
  isMissingAddressInfo: boolean;

  onClick(): void;
}

function AddressContinueButton({
  onClick,
  disabled,
  isAddressCompleted,
  isMissingAddressInfo,
}: Props): JSX.Element | null {
  const [isVisible, toggleVisible] = useReducer(
    (state, action) => !state,
    true
  );

  // Скрываем кнопку, если меняется заполненность адреса
  useEffect(() => {
    if (isAddressCompleted && !disabled) {
      toggleVisible(false);
    }
    if (isAddressCompleted && !isVisible) {
      toggleVisible(false);
    }
    if (!(isAddressCompleted || disabled) && !isVisible) toggleVisible(true);
  }, [isAddressCompleted, disabled]);

  if ((isAddressCompleted && !isVisible) || isMissingAddressInfo) return null;
  return (
    <Button
      className="AddressContinueBtn"
      primary
      onClick={disabled ? () => {} : onClick}
      disabled={disabled}
    >
      <Trans>Продолжить</Trans>
    </Button>
  );
}

const mapStateToProps = createStructuredSelector({
  disabled: getDisableContinueButton,
  isAddressCompleted,
  isMissingAddressInfo: missingAddressInfo,
});

const mapDispatchToProps = (
  dispatch: Dispatch,
  { model }: { model: PersonModel }
) => ({
  onClick() {
    dispatch({ type: `${model}/address/validate` });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddressContinueButton);
